import React from 'react';
import { theme } from '../../styles/theme';

const AlertModal = ({ isOpen, onClose, title, message, type = 'info' }) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          icon: '✓',
          iconColor: theme.colors.success,
          iconBg: '#D4EDDA',
          borderColor: theme.colors.success,
        };
      case 'error':
        return {
          icon: '✕',
          iconColor: theme.colors.error,
          iconBg: '#F8D7DA',
          borderColor: theme.colors.error,
        };
      case 'warning':
        return {
          icon: '⚠',
          iconColor: '#856404',
          iconBg: '#FFF3CD',
          borderColor: '#856404',
        };
      default: // info
        return {
          icon: 'ℹ',
          iconColor: theme.colors.primary,
          iconBg: '#D1ECF1',
          borderColor: theme.colors.primary,
        };
    }
  };

  const typeStyles = getTypeStyles();

  const overlayStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: theme.spacing.lg,
  };

  const modalStyles = {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.lg,
    maxWidth: '500px',
    width: '100%',
    maxHeight: 'calc(100vh - 2rem)',
    overflowY: 'auto',
    boxShadow: theme.shadows.xl,
    animation: 'slideIn 0.2s ease-out',
  };

  const headerStyles = {
    padding: theme.spacing.lg,
    borderBottom: `1px solid ${theme.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
  };

  const iconStyles = {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: typeStyles.iconBg,
    color: typeStyles.iconColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    flexShrink: 0,
  };

  const titleStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.text,
    margin: 0,
  };

  const bodyStyles = {
    padding: theme.spacing.lg,
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.text,
    lineHeight: '1.6',
  };

  const footerStyles = {
    padding: theme.spacing.lg,
    borderTop: `1px solid ${theme.colors.border}`,
    display: 'flex',
    justifyContent: 'flex-end',
  };

  const buttonStyles = {
    padding: `${theme.spacing.sm} ${theme.spacing.xl}`,
    backgroundColor: theme.colors.primary,
    color: theme.colors.textOnDark,
    border: 'none',
    borderRadius: theme.borderRadius.md,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.semibold,
    cursor: 'pointer',
    transition: theme.transitions.base,
    fontFamily: theme.typography.fontFamily.secondary,
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      
      <div style={overlayStyles} onClick={handleOverlayClick}>
        <div style={modalStyles}>
          <div style={headerStyles}>
            <div style={iconStyles}>
              {typeStyles.icon}
            </div>
            <h2 style={titleStyles}>{title || 'Alert'}</h2>
          </div>
          
          <div style={bodyStyles}>
            {message}
          </div>
          
          <div style={footerStyles}>
            <button
              style={buttonStyles}
              onClick={onClose}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = theme.colors.primaryDark;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = theme.colors.primary;
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlertModal;

